import { createServiceToken, type PaginatedResult } from "@nasam/kernel";

// The geofence picker in the alert form. Geofences belong to Fleet Monitoring,
// so Core names only the slice of them it reads (id and name); Fleet
// Monitoring binds its repository under this token, and the field is left out
// when that module isn't installed.

export interface GeofenceLookup {
  readonly id: string;
  readonly name: string;
}

export interface GeofenceLookupQuery {
  readonly page: number;
  readonly limit: number;
  readonly search?: string;
}

export interface GeofenceLookupRepository {
  list(query: GeofenceLookupQuery): Promise<PaginatedResult<GeofenceLookup>>;
}

export const geofenceLookupRepositoryToken =
  createServiceToken<GeofenceLookupRepository>("alerts.geofence-lookup");

export { useGeofenceOptions } from "../features/alerts/application/useGeofenceOptions";
export type {
  GeofenceOption,
  UseGeofenceOptionsResult,
} from "../features/alerts/application/useGeofenceOptions";

/** What `GET /geofences` checks. Without it the API answers 403, which sends
 *  the whole app to /unauthorized, so the picker only asks when it's held. */
export const GEOFENCE_LOOKUP_PERMISSION =
  "fleet_monitoring.tracking_management.geofence_management_list.view";
